export const DEFAULT_ZOOM_LEVEL = 0.8;

export const ZOOM_CONFIG = {
  MIN: 0.65,
  MAX: 1.25,
  DEFAULT: DEFAULT_ZOOM_LEVEL,
  EXPORT_MODE: 1,
  STEP: 0.05,
  STORAGE_KEY: 'scalar-app-zoom-level',
} as const;
